import Enumeration from 'Lib/utilities/Enumeration';

const IdentityReportStatuses = new Enumeration([
    { id: 1, name: 'Processing' },
    { id: 2, name: 'Completed' },
    { id: 3, name: 'Failed' },
    { id: 4, name: 'Not Enabled' },
    { id: 5, name: 'Skipped' },
    { id: 6, name: 'Resent' }
]);

export default IdentityReportStatuses;
